export default function MInfoShow({ label, data, checkEmpty = false }) {
  return (
    <p className={`m-info-show ${checkEmpty && data === "empty" ? 'checkEmpty' : ''}`}>
      <span>{`${label}:`}</span>
      <span>{data}</span>
    </p>
  );
}
